import React, { useState } from "react";

export function MenuLateralSuper({ info, goStadistics, gohome, addEntitie, addCotiz, addEquip, goCreateUser, goTogestionCotiz, 
    goTogestionUsers, goToManegementEquipment, goToManegementEntitie, goAprovedCotiz, goAssigned, goListInform}) {
    //const userNameToShow = infoUser.userName + "....";
    var userNameToShow = info;
    userNameToShow = "santiago";

    //eventos visuales

    const [showSubmenuCotizaciones, setShowSubmenuContizaciones] = useState(false);
    const [showSubmenuUsuarios, setShowSubmenuUsuarios] = useState(false);
    const [showSubmenuEntidades, setShowSubmenuEntidades] = useState(false);
    const [showSubmenuEquipos, setShowSubmenuEquipos] = useState(false);
    const [showSubmenuInformes, setShowSubmenuInformes] = useState(false);

    const toggleSubmenuCotizaciones = () => {
        setShowSubmenuContizaciones(!showSubmenuCotizaciones);
        //setShowSubmenuUsuarios(false)
    };

    const toggleSubmenuUsuarios = () => {
        setShowSubmenuUsuarios(!showSubmenuUsuarios);
        //setShowSubmenuContizaciones(false);
    };

    const toggleSubmenuEntidades = () => {
        setShowSubmenuEntidades(!showSubmenuEntidades);
        //setShowSubmenuContizaciones(false);
    }

    const toggleSubmenuEquipos = () => {
        setShowSubmenuEquipos(!showSubmenuEquipos);
        //setShowSubmenuContizaciones(false);
    }

    const toggleSubmenuInformes = () => {
        setShowSubmenuInformes(!showSubmenuInformes);
        //setShowSubmenuContizaciones(false);
    }

    //eventos externos
    /*
    const clickToGoHome = (event) => {
        event.preventDefault()
        gohome()
    }
    */
    const clickToGoStadistics = (event) => {
        event.preventDefault()
        goStadistics()
    }

    const clickToGoCreateUser = (event) => {
        event.preventDefault()
        goCreateUser()
    }

    const clickToGoCreateCotiz = (event) => {
        event.preventDefault()
        addCotiz()
    }

    const clickToAddEntitie = (event) => {
        //event.preventDefault()
        addEntitie()
    }

    const clickToAddEquip = (event) => {
        //event.preventDefault()
        addEquip()
    }

    const clickTogoTogestionCotiz = (event) => {
        event.preventDefault()
        goTogestionCotiz()
    }
    
    const clickTogoTogestionUsers = (event) => {
        event.preventDefault()
        goTogestionUsers()
    }

    const clickTogoToManagementEquipment = (event) => {
        event.preventDefault()
        goToManegementEquipment()
    }

    const clickTogoToManagementEntitie = (event) => {
        event.preventDefault()
        goToManegementEntitie()
    }

    const clickToGoAprovedCotiz = (event) => {
        event.preventDefault()
        goAprovedCotiz()
    }

    const clickGoListInform = (event) => {
        event.preventDefault()
        goListInform()
    }

    //si se borran los formularios se debe borrar href="#"
    return (
        <div className="menu-lateral">
            <ul style={{ marginTop: '80px' }}>
                <li className={`menu-item`}>
                    <a href="#" onClick={clickToGoStadistics}>Inicio</a>
                </li>
                <li className={`menu-item has-submenu ${showSubmenuUsuarios ? 'active' : ''}`}>
                    <a onClick={toggleSubmenuUsuarios}>Usuarios</a>
                </li>
                {showSubmenuUsuarios && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickToGoCreateUser}>- Crear usuario</a>
                    </li>
                )}
                {showSubmenuUsuarios && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickTogoTogestionUsers}>- Lista de usuarios</a>
                    </li>
                )}
                <li className={`menu-item ${showSubmenuCotizaciones ? 'active' : ''}`}>
                    <a onClick={toggleSubmenuCotizaciones}>Cotizaciones</a>
                </li>
                {showSubmenuCotizaciones && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickToGoCreateCotiz}>- Crear cotizaciones</a>
                    </li>
                )}
                {showSubmenuCotizaciones && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickTogoTogestionCotiz}>- Listado de cotizaciones</a>
                    </li>
                )}
                {showSubmenuCotizaciones && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickToGoAprovedCotiz}>- Cotizaciones aprobadas</a>
                    </li>
                )}
                <li className={`menu-item ${showSubmenuEntidades ? 'active' : ''}`}>
                    <a onClick={toggleSubmenuEntidades}>Entidades</a>
                </li>
                {showSubmenuEntidades && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickToAddEntitie}>- Crear entidad</a>
                    </li>
                )}
                {showSubmenuEntidades && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickTogoToManagementEntitie}>- Listado de Entidades</a>
                    </li>
                )}
                <li className={`menu-item ${showSubmenuEquipos ? 'active' : ''}`}>
                    <a onClick={toggleSubmenuEquipos}>Equipos</a>
                </li>
                {showSubmenuEquipos && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickToAddEquip}>- Crear Equipo</a>
                    </li>
                )}
                {showSubmenuEquipos && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickTogoToManagementEquipment}>- Listado de equipos</a>
                    </li>
                )}
                <li className={`menu-item ${showSubmenuInformes ? 'active' : ''}`}>
                    <a onClick={toggleSubmenuInformes}>Informes</a>
                </li>
                {showSubmenuInformes && (
                    <li className={`menu-item`} style={{backgroundColor: '#979797'}}>
                        <a href="#" onClick={clickGoListInform}>- Listado de informes</a>
                    </li>
                )}
                <li className={`menu-item`}>
                    <a href="#">Contacto</a>
                </li>
            </ul>
        </div>
    );
}